// Modalità di sovrascrittura per gli upsert di import (string enum allineato al backend CsvTools).
// Si applica solo ai record ESISTENTI; i nuovi sono sempre creati in ogni modalità.
// Condiviso tra import Ordini di Vendita (feature 040) e import Anagrafiche (feature 053).
export enum ModalitaSovrascrittura {
  Salta = 'Salta',
  AggiornaTutto = 'AggiornaTutto',
  AggiornaCampiVuoti = 'AggiornaCampiVuoti',
}
